/* eslint-disable react/forbid-elements */

export interface BrandSelectorProps {}

export const BrandSelector = () => {
  return (
    <div className="p-5">
      <ul>
        <li>
          {/* eslint-disable-next-line node/no-process-env */}
          <a href={`${process.env.PUBLIC_URL}/?brand=lottomatica`}>LOTTOMATICA</a>
        </li>
        <li>
          {/* eslint-disable-next-line node/no-process-env */}
          <a href={`${process.env.PUBLIC_URL}/?brand=goldbet`}>GOLDBET</a>
        </li>
        <li>
          {/* eslint-disable-next-line node/no-process-env */}
          <a href={`${process.env.PUBLIC_URL}/?brand=planetwin365`}>PLANETWIN365</a>
        </li>
        <li>
          {/* eslint-disable-next-line node/no-process-env */}
          <a href={`${process.env.PUBLIC_URL}/?brand=lottomaticaservizi`}>LOTTOMATICA SERVIZI</a>
        </li>
      </ul>
      <p>Questa schermata comparirà solo negli ambienti di sviluppo/test/pre-produzione, mai in produzione.</p>
      <p>Il reverse proxy di lottomatica rimanderà a noi aggiungendo un queryParam:</p>
      <ul>
        <li>https://site-lottomatica.b2x.it/store-locator?brand=lottomatica</li>
        <li>https://site-lottomatica.b2x.it/store-locator?brand=goldbet</li>
        <li>https://site-lottomatica.b2x.it/store-locator?brand=planetwin365</li>
        <li>https://site-lottomatica.b2x.it/store-locator?brand=lottomaticaservizi</li>
      </ul>
      <p>La nostra web-app, in fase di inizializzazione, seguirà i seguenti passi:</p>
      <ul>
        <li>Leggerà il query param.</li>
        <li>Farà un check di validità del queryParam stesso.</li>
        <li>Se è valido, lo salverà nel localStorage.</li>
        <li>Farà un redirect a se stesso, stavolta senza queryParam.</li>
        <li>
          Nella nuova iterazione (senza queryParam) la web-app leggerà dal localStorage il brand desiderato e si
          inizializzarà con quello.
        </li>
      </ul>
    </div>
  );
};
